<div class="p-inputgroup">
    <div class="p-inputtext" style="height: 2rem; overflow-y: auto; cursor: default;">
        <p-chip
            *ngIf="(showCountOnly && organizationPicker?.length > 0) || organizationPicker?.length > 1"
            styleClass="custom-chip"
            [removable]="!disabled"
            (onRemove)="onRemove()">{{ 'hrPerOrganizationGeneralInfo.organizationSelectedText' | translate:{ count: organizationPicker?.length } }}
        </p-chip>
        <p-chip *ngIf="organizationPicker?.length==1 && !showCountOnly"
                styleClass="custom-chip" [removable]="!disabled"
                (onRemove)="onRemove()">{{ organizationPicker[0]?.perObjectDefinitionText }}
        </p-chip>
    </div>
    <button (click)="onShow()" [disabled]="disabled" id="organizationPickerButton" label=" "
            class="btn-icon-only hvl-entity-picker-search-button" pButton type="button">
        <i aria-hidden="true" class="material-icons">search</i>
    </button>
</div>
<a *ngIf="selectionMode == 'multiple' && organizationPicker?.length > 1" class="text-primary cursor-pointer underline"
   (click)="op.toggle($event)">
    {{ 'hrPerOrganizationGeneralInfo.show' | translate }}
</a>
<p-overlayPanel #op [showCloseIcon]="false" [style]="{width: '450px'}">
    <div *ngFor="let org of organizationPicker;let i = index"> {{ i + 1 + '. ' + org.perObjectDefinitionText }}</div>
</p-overlayPanel>
